<template>
  <div class="Fuell-Table Fuell-Table--budget-members">
    <div class="Fuell-ToolbarSearch">
      <span class="Fuell-ToolbarSearch--icon">
        <img
          :src="require('@/assets/img/icons/icon-search.svg')"
          alt="search"
        >
      </span>
      <input
        class="Fuell-ToolbarSearch--input"
        type="text"
        v-model="query"
        :placeholder="$t('ACTION_SEARCH')"
      >
    </div>

    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item">
        <span v-t="{path: 'budget_detail_members'}"></span>
      </div>
      <div class="Fuell-Table--item"></div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'budget_detail_budget_assigned'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'budget_detail_budget_spent'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'budget_detail_budget_available'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'budget_detail_budgter_spent_vs_available'}"></span>
      </div>
    </div>
    <div class="Fuell-Table--content">
      <budget-detail-team-members-table-row
        v-for="member in members"
        :member="member"
        :key="member.id"
      ></budget-detail-team-members-table-row>
    </div>
  </div>
</template>

<script>
import BudgetDetailTeamMembersTableRow from './BudgetDetailTeamMembersTableRow'
import { sortBy } from 'lodash-es'
export default {
  name: 'BudgetDetailTeamMembersTable',
  components: { BudgetDetailTeamMembersTableRow },
  data () {
    return {
      query: ''
    }
  },
  computed: {
    budgetId () {
      return this.$route.params.id
    },
    currentBudget () {
      return this.$store.getters['BudgetsStore/currentBudget'] || false
    },
    members () {
      if (this.query) {
        return sortBy(this.currentBudget.userBudgets.filter(el => {
          const memberMatchesFirstName = el.user.firstName.toLowerCase().includes(this.query.toLowerCase().trim())
          const memberMatchesLastName = el.user.lastName.toLowerCase().includes(this.query.toLowerCase().trim())
          return memberMatchesFirstName || memberMatchesLastName
        })
          , (el) => el.user.firstName) || []
      }
      return sortBy(this.currentBudget.userBudgets, (el) => el.user.firstName) || []
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/tables/member-budgets.scss";
</style>
